import * as React from 'react';
import { Search } from '../../components';
import { IExplorerProperties } from "../../models";
import { CheckBoxList } from "../../assets/CheckBoxList/CheckBoxList";
import { FILTER_FOCUS_PROPERTY } from "../../config";
import { isNullOrUndefined, getUrlParameter, safe, addItemToGoogleTracking } from "../../utils";
import { LoadingIcon } from "./LoadingIcon/LoadingIcon";

const styles = require('./Filtersidebar.pcss');
const FaCaretLeft = require('react-icons/lib/fa/caret-left');
const FaAngleRight = require('react-icons/lib/fa/angle-right');

interface IState {
    width?: number;
    focusOptions?: {
        label: string;
        value: string;
        selected?: boolean;
    }[];
}

export class Filtersidebar extends React.Component<IExplorerProperties, IState>{
    constructor(props) {
        super(props);
        this.state = {
            focusOptions: [{
                label: "M&G's funds in focus",
                value: 'featured',
                selected: false
            }]
        };

        this.handleResetFilters = this.handleResetFilters.bind(this);
        this.changeFeatured = this.changeFeatured.bind(this);
    }

    updateLocalState() {
        this.setState({ width: window.innerWidth });
    }

    handleResetFilters() {
        let { appParams } = this.props;
        addItemToGoogleTracking(appParams, "advancefilter_fundpage_reset", { eventLabel: "Reset" });
        let { changeFilter, filter } = this.props;
        if (filter) {
            filter.search = [];
        }
        changeFilter(filter, this.props.appParams);
    }

    componentWillMount() {
        this.updateLocalState();
        let { filterOptions } = this.props;
        let urlParams = ["asset_class"];

        for (let param of urlParams) {
            let paramValue = getUrlParameter(location.href, param);
            let [filterOption] = filterOptions[param].filter(item => !isNullOrUndefined(paramValue) && item.value.toLowerCase() === paramValue.toLowerCase());
            if (filterOption) {
                filterOption.selected = true;
            }
        }
    }

    changeFeatured(isSelected) {
        this.setState({
            focusOptions: [{
                label: "M&G's funds in focus",
                value: 'featured',
                selected: isSelected
            }]
        });
    }

    render() {
        let { changeFilter, filter, filterOptions, appParams, typeahead, isLoading, funds, disclaimers } = this.props;

        let { width, focusOptions } = this.state;
        let changeOverrideFilter = function (options) { changeFilter(options, appParams); };

        let isPrivateInvestor = appParams.clienttype === "pri";
        let isCharity = appParams.clienttype === "cha";
        let isAdvisor = appParams.clienttype === "adv";
        let isDiscretionaryWealth = appParams.clienttype === "diw";
        let isUK = appParams.region.toLowerCase() === "uk"

        let isICAV = appParams.productrange.toUpperCase() === "ICAV";
        let isOEIC = appParams.productrange.toUpperCase() === "OEIC";
        let isPPL = appParams.productrange.toUpperCase() === "PPL";

        let showFeatured = isUK && ((isOEIC && !isPrivateInvestor && !isCharity) || (isICAV && !isDiscretionaryWealth));
        let showStyle = isUK && ((isOEIC && !isPrivateInvestor && !isCharity && !isAdvisor && !isDiscretionaryWealth) || (isICAV && !isDiscretionaryWealth));
        let hideMStarRating = isUK && (isICAV && isDiscretionaryWealth);


        if (!isNullOrUndefined(filterOptions.asset_class) && ((appParams.clienttype === "cha" || appParams.clienttype === "pri") && appParams.region === "uk")) {
            for (let item of filterOptions.asset_class) {
                if (item.label.toLowerCase() === "fixed income") {
                    item.label = "Fixed income (bonds)";
                }
            }
        }

        if (width < 1196) {
            if (isLoading) {
                return <LoadingIcon isLoading={isLoading} />;
            }
        }

        return (
            <section>
                <div id="leftPanel" className={styles.leftpanel}>
                    <div className={styles.ksw_filters_vt}>
                        <ul className={styles.filters_wrapper}>
                            <li>
                                <h3>ADVANCED FILTER</h3>
                            </li>
                        </ul>
                    </div>
                    <Search
                        filterOptions={filterOptions}
                        changeFilter={changeFilter}
                        appParams={appParams}
                        isFundPage={false}
                        isMiniFinder={false}
                        isFilterSidebar={true}
                        typeahead={typeahead}
                        filter={filter}>
                    </Search>
                    {(() => {
                        if (showFeatured) {
                            return <div className={styles.featured}>
                                <CheckBoxList
                                    changeSelected={this.changeFeatured}
                                    appParams={appParams}
                                    tooltip={safe(() => disclaimers[`tooltip_featured_funds`][0].disclaimers[0].disclaimer, null)}
                                    gaKey="advancefilter_fundpage_feature"
                                    isLoading={isLoading}
                                    heading={"FEATURED FUNDS"}
                                    property={FILTER_FOCUS_PROPERTY}
                                    options={focusOptions}
                                    onChange={changeOverrideFilter}
                                    filter={filter}>
                                </CheckBoxList>
                            </div>;
                        }
                    })()}
                    {(() => {
                        if (showStyle) {
                            return <CheckBoxList
                                appParams={appParams}
                                tooltip={safe(() => disclaimers[`tooltip_style`][0].disclaimers[0].disclaimer, null)}
                                gaKey="advancefilter_fundpage_style"
                                isLoading={isLoading}
                                heading={"STYLE"}
                                property={"style"}
                                options={filterOptions.style}
                                onChange={changeOverrideFilter}
                                filter={filter}>
                            </CheckBoxList>;
                        }
                    })()}
                    {(() => {
                        if (!isPPL && isPrivateInvestor) {
                            return <CheckBoxList
                                appParams={appParams}
                                tooltip={safe(() => disclaimers[`tooltip_product`][0].disclaimers[0].disclaimer, null)}
                                gaKey="advancefilter_fundpage_product"
                                isLoading={isLoading}
                                heading={"PRODUCT"}
                                property={"product_availability"}
                                options={filterOptions.product_availability}
                                onChange={changeOverrideFilter}
                                filter={filter}>
                            </CheckBoxList>;
                        }
                    })()}
                    {(() => {
                        if (true) {
                            return <CheckBoxList
                                appParams={appParams}
                                tooltip={safe(() => disclaimers[`tooltip_asset_class`][0].disclaimers[0].disclaimer, null)}
                                gaKey="advancefilter_fundpage_asset"
                                isLoading={isLoading}
                                heading={"ASSET CLASS"}
                                property={"asset_class"}
                                options={filterOptions.asset_class}
                                onChange={changeOverrideFilter}
                                filter={filter}>
                            </CheckBoxList>;
                        }
                    })()}
                    {(() => {
                        if (!isPPL) {
                            return <CheckBoxList
                                appParams={appParams}
                                tooltip={safe(() => disclaimers[`tooltip_share_class`][0].disclaimers[0].disclaimer, null)}
                                gaKey="advancefilter_fundpage_share_class"
                                isLoading={isLoading}
                                heading={"SHARE CLASS"}
                                property={"shareclass_letter"}
                                options={filterOptions.shareclass_letter}
                                onChange={changeOverrideFilter}
                                filter={filter}>
                            </CheckBoxList>
                        }
                    })()}
                    {(() => {
                        if (true) {
                            return <CheckBoxList
                                appParams={appParams}
                                tooltip={safe(() => disclaimers[`tooltip_share_type`][0].disclaimers[0].disclaimer, null)}
                                gaKey="advancefilter_fundpage_share_class_type"
                                isLoading={isLoading}
                                heading={"SHARE TYPE"}
                                property={"share_type"}
                                options={filterOptions.share_type}
                                onChange={changeOverrideFilter}
                                filter={filter}>
                            </CheckBoxList>;
                        }
                    })()}
                    {(() => {
                        if (true) {
                            return <CheckBoxList
                                appParams={appParams}
                                tooltip={safe(() => disclaimers[`tooltip_region`][0].disclaimers[0].disclaimer, null)}
                                gaKey="advancefilter_fundpage_region"
                                isLoading={isLoading}
                                heading={"REGION"}
                                property={"regions"}
                                options={filterOptions.regions}
                                onChange={changeOverrideFilter}
                                filter={filter}>
                            </CheckBoxList>;
                        }
                    })()}
                    {(() => {
                        if (appParams.region !== "uk") {
                            return <CheckBoxList
                                appParams={appParams}
                                tooltip={safe(() => disclaimers[`tooltip_currency`][0].disclaimers[0].disclaimer, null)}
                                gaKey="advancefilter_fundpage_currency"
                                isLoading={isLoading}
                                heading={"CURRENCY"}
                                property={"shareclass_currency_code"}
                                options={filterOptions.currency}
                                onChange={changeOverrideFilter}
                                filter={filter}>
                            </CheckBoxList>
                        }
                    })()}
                    {(() => {
                        if (!isPPL && !hideMStarRating) {
                            return <div className={styles.morningStar}>
                                <CheckBoxList
                                    appParams={appParams}
                                    tooltip={safe(() => disclaimers[`tooltip_morningstar_rating™`][0].disclaimers[0].disclaimer, null)}
                                    gaKey="scroll_filter_fundpage_morningstar"
                                    isLoading={isLoading}
                                    heading={"MORNINGSTAR RATING"}
                                    property={"morningstar_rating"}
                                    options={filterOptions.morningstar_rating}
                                    onChange={changeOverrideFilter}
                                    filter={filter}>
                                </CheckBoxList>
                            </div>;
                        }
                    })()}

                    <div className={`${styles.noBorders} ${styles.ksw_filters_vt}`}>
                        <button
                            onClick={this.handleResetFilters.bind(this)}
                            className={styles.loadMore} type="button"
                        >
                            RESET FILTERS
                        </button>
                    </div>
                </div >
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/Filtersidebar/Filtersidebar.tsx